import i18next from 'i18next';

export const getDayLabel = (daysQuantity: number) => {
   const pluralRules = new Intl.PluralRules('pl-PL');
   const grammaticalNumber = pluralRules.select(daysQuantity);
   return grammaticalNumber === 'one' ? i18next.t('labels.day_one') : i18next.t('labels.day_many');
};
